<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <h1 class="col-sm-6">{{ title }}</h1>
      <app-breadcrumb
        class="col-sm-6"
        [breadcrumb]="breadcrumbs"
      ></app-breadcrumb>
    </div>
  </div>
</section>
